// extracted by mini-css-extract-plugin
export default {"wrapper":"SpectrogramPlot_wrapper__R4zl7","container":"SpectrogramPlot_container__7DrzD"};